import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { PassageiroOrdemServicoVm } from '../../../core/models/passenger-os.model'

// Read-only — não é o CRUD de passageiros da proposta/logística (passengers.component),
// é só o "ver mais" da tela de Acompanhamento de OS.
@Component({
  selector: 'modal-passageiros-os',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinner],
  templateUrl: './modal-passageiros-os.component.html',
  styleUrl: './modal-passageiros-os.component.scss',
})
export class ModalPassageirosOsComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { osId: string },
    private dialogRef: MatDialogRef<ModalPassageirosOsComponent>,
    private passengerOrdemService: PassengerOrdemService,
    private snackbar: SnackbarCustomService,
  ) {}

  loading = false
  passageiros: PassageiroOrdemServicoVm[] = []

  ngOnInit(): void {
    this.loadPassageiros()
  }

  loadPassageiros(): void {
    this.loading = true
    this.passengerOrdemService.listPassengerByOs({ ordemServicoId: this.data.osId }).subscribe({
      next: (res: any) => { this.passageiros = res.data ?? [] },
      error: (err: any) => { this.loading = false; this.snackbar.errorRequest(err) },
      complete: () => { this.loading = false },
    })
  }

  trechoDisplay(p: PassageiroOrdemServicoVm, prefix: 'origem' | 'destino'): string {
    const anyP = p as any
    const sigla = anyP[`${prefix}AeroSigla`]
    const logradouro = anyP[`${prefix}Logradouro`]
    const cidade = anyP[`${prefix}Cidade`]
    if (sigla) return sigla
    const partes = [logradouro, cidade].filter((v) => !!v)
    return partes.length > 0 ? partes.join(' - ') : '-'
  }

  vooDisplay(p: PassageiroOrdemServicoVm): string {
    if (!p.companhia && !p.voo) return '-'
    return `${p.companhia ?? '-'} ${p.voo ?? ''}`.trim()
  }

  close(): void { this.dialogRef.close() }
}
